const goTopBtnHandler = () => {
  const goTopBtn = document.querySelector(".btn--go-top");
  if (!goTopBtn) {
    return;
  }

  goTopBtn.addEventListener("click", goTop);
  window.addEventListener("scroll", trackScroll);

  function trackScroll() {
    const offset = window.pageYOffset;
    const pageHeight = document.documentElement.clientHeight;

    if (offset > pageHeight / 2) {
      goTopBtn.classList.add("visible");
    } else {
      goTopBtn.classList.remove("visible");
    }
  }

  function goTop() {
    if (window.pageYOffset > 0) {
      window.scrollBy(0, -70);
      setTimeout(goTop, 0);
    }
  }
};

export { goTopBtnHandler };
